module.exports = __webpack_public_path__ + "static/img/adro.90a15215.png";